import _ from 'lodash';

// check dirty alongside changed to make sure that the change was not
// internal by vue or during component initialization.
export const hasUserChangedAny = fields => !!_.values(fields).find(field => field.dirty && field.changed);

export default { hasUserChangedAny };
